@if (licenseForm) {
<div class="page gray-font-color font-family bodyBackground profile-license">
  @if (errorMessage) {
  <mat-error class="error padding-left-md">
    {{ errorMessage }}
  </mat-error>
  }
  <form [formGroup]="licenseForm">
    <div class="header-navigation-back">
      <mat-icon (click)="goBack()" data-test="back-arrow-icon">arrow_back</mat-icon>
      <span class="title" data-test="edit-button">License</span>
      <button mat-raised-button
        [disabled]="!licenseForm.valid || loading || currentStatus == 'processing' || (areImagesRequired && !areBothImagesUploaded)"
        [class.save-disabled]="!licenseForm.valid || loading || currentStatus == 'processing' || (areImagesRequired && !areBothImagesUploaded)"
        class="save-button" (click)="onSubmit()" data-test="save-button" data-testid="save-button">
        Save
      </button>
    </div>
    @if (currentStatus == 'processing' || currentStatus == 'failed') {
    <div class="description-banner">
      <div class="description" [innerHTML]="currentStatusMessage"></div>
    </div>
    }
    @if (licenseLoaded) {
    <div class="content">
      <!-- Combined License Section: Images + Form -->
      <div class="license-section combined-section">
        <!-- Inline Image Cards - Show for existing licenses or when images uploaded -->
        @if (licenseExists || frontImageExists || backImageExists) {
        <div class="license-images-container">
          <app-license-image-card [imageUrl]="frontImageUrl" [imageType]="'front'" [isUploaded]="frontImageExists"
            [disabled]="isUploadingImage || loading" (onUpload)="openUploadBottomSheet('front')"
            (onReplace)="openUploadBottomSheet('front')"
            (onView)="onViewLicenseImage('front')"></app-license-image-card>

          <app-license-image-card [imageUrl]="backImageUrl" [imageType]="'back'" [isUploaded]="backImageExists"
            [disabled]="isUploadingImage || loading" (onUpload)="openUploadBottomSheet('back')"
            (onReplace)="openUploadBottomSheet('back')" (onView)="onViewLicenseImage('back')"></app-license-image-card>
        </div>
        }

        @if (isUploadingImage) {
        <div class="upload-progress">
          <mat-spinner diameter="24"></mat-spinner>
          <span>Uploading...</span>
        </div>
        }

        <!-- First-time user: Show upload prompt when no images uploaded -->
        @if (!licenseExists && !frontImageExists && !backImageExists) {
        <div class="upload-prompt-card" data-testid="license-upload-prompt">
          <div class="prompt-images">
            <div class="prompt-image-item">
              <img src="assets/images/dl-front.png" alt="Front license" class="license-placeholder-thumb" />
              <span class="image-label">FRONT</span>
            </div>
            <div class="prompt-image-item">
              <img src="assets/images/dl-back.png" alt="Back license" class="license-placeholder-thumb" />
              <span class="image-label">BACK</span>
            </div>
          </div>
          <h3 class="prompt-title">Upload Your License Images</h3>
          <p class="prompt-message">Please upload both front and back images of your license. The form will appear next.
          </p>
          <button mat-raised-button color="primary" class="upload-cta-button" (click)="openUploadBottomSheet()"
            data-testid="upload-license-images-btn">
            <mat-icon>photo_camera</mat-icon>
            Upload Images
          </button>
          <!-- <div class="divider-with-text">
            <span>or</span>
          </div>
          <button mat-button class="manual-entry-button" (click)="showFormManually = true">
            Enter Details Manually
          </button> -->
        </div>
        }

        <!-- Form Fields - Show when: editing existing license OR images uploaded OR user chose manual entry -->
        @if (licenseExists || frontImageExists || backImageExists || showFormManually) {
        <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
          <mat-label>License Number</mat-label>
          <input matInput formControlName="licenseNumber" data-test="license-number" data-testid="license-number"
            required />
          @if (licenseForm.touched && licenseForm.invalid) {
          <mat-error data-testid="license-warning">
            {{ REQUIRED_FIELD_MESSAGE }}
          </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
          <mat-label>Issue Date</mat-label>
          <input matInput readonly formControlName="issueDate" [matDatepicker]="issueDate" (focus)="issueDate.open()"
            (click)="issueDate.open()" [max]="maxDate" (dateChange)="issueDateChangeEvent($event)"
            data-testid="issue-date" required />
          <mat-datepicker-toggle matSuffix [for]="issueDate" data-test="issue-date-form-field"></mat-datepicker-toggle>
          <mat-datepicker touchUi="true" #issueDate></mat-datepicker>
          @if (licenseForm.get('issueDate').touched && licenseForm.get('issueDate').invalid) {
          <mat-error>
            {{ REQUIRED_FIELD_MESSAGE }}
          </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
          <mat-label>Expiration Date</mat-label>
          <input matInput readonly formControlName="expiryDate" [matDatepicker]="expiryDate" [min]="expiryMinDate"
            (focus)="expiryDate.open()" (click)="expiryDate.open()" [disabled]="!licenseForm.get('issueDate').value"
            data-testid="expiration-date" required />
          <mat-datepicker-toggle matSuffix [for]="expiryDate"
            data-test="expiry-date-form-field"></mat-datepicker-toggle>
          <mat-datepicker touchUi="true" #expiryDate></mat-datepicker>
          @if (licenseForm.get('expiryDate').touched && licenseForm.get('expiryDate').invalid) {
          <mat-error>
            {{ REQUIRED_FIELD_MESSAGE }}
          </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
          <mat-label>Issuing Country</mat-label>
          <mat-select #issuingCountrySelect formControlName="issuingCountry"
            (selectionChange)="onCountryChange($event.value)" required data-test="issuing-country"
            data-testid="issuing-country">
            @for (country of issuingCountry; track country) {
            <mat-option [value]="country.code" [attr.data-testid]="'country-' + country?.value?.toLowerCase()"
              data-test="country-name">
              {{ country.value }}
            </mat-option>
            }
          </mat-select>
          @if (licenseForm.get('issuingCountry').touched && licenseForm.get('issuingCountry').invalid) {
          <mat-error data-testid="country-warning">
            {{ REQUIRED_FIELD_MESSAGE }}
          </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
          <mat-label>Issuing State/Province</mat-label>
          <mat-select #issuingProvinceSelect (focus)="onSelectFocus(issuingProvinceSelect)"
            formControlName="issuingProvince" (selectionChange)="onProvinceChange($event.value)" required
            data-test="issuing-province" data-testid="issuing-province">
            @for (province of stateProvinces; track province) {
            <mat-option [value]="province.value" [attr.data-testid]="'province_state-' + province?.name?.toLowerCase()">
              {{ province.name }}
            </mat-option>
            }
          </mat-select>
          @if (licenseForm.get('issuingProvince').touched && licenseForm.get('issuingProvince').invalid) {
          <mat-error data-testid="provinceState-warning">
            {{ REQUIRED_FIELD_MESSAGE }}
          </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width" data-test="license-class-field"
          subscriptSizing="dynamic">
          <mat-label>License Class</mat-label>
          <mat-select #licenseTypeSelect (focus)="onSelectFocus(licenseTypeSelect)" formControlName="licenseType"
            required data-testid="license-class" data-test="license-class">
            @for (license of provinceLicenseClass; track license) {
            <mat-option [value]="license" data-test="class-value" [attr.data-testid]="'type-' + license?.toLowerCase()">
              {{ license }}
            </mat-option>
            }
          </mat-select>
          @if (licenseForm.get('licenseType').touched && licenseForm.get('licenseType').invalid) {
          <mat-error data-testid="licenseType-warning">
            {{ REQUIRED_FIELD_MESSAGE }}
          </mat-error>
          }
        </mat-form-field>
        <div class="field-row">
          <div>
            <span class="field-header">
              Do you have Air Brake (Z) endorsement?
              @if (isAirBrakeRequired) {
              <span class="required-indicator">*</span>
              }
            </span>
          </div>
          <mat-radio-group formControlName="hasAirBreakEndorsment" class="radio-group" color="primary"
            data-test="air-break-endorsement">
            <mat-radio-button [value]="true" class="radio-button">Yes</mat-radio-button>
            <mat-radio-button [value]="false" class="radio-button">No</mat-radio-button>
          </mat-radio-group>
          @if (isAirBrakeRequired && licenseForm.get('hasAirBreakEndorsment').touched &&
          licenseForm.get('hasAirBreakEndorsment').invalid) {
          <mat-error class="field-error" data-testid="airBrake-warning">
            {{ REQUIRED_FIELD_MESSAGE }}
          </mat-error>
          }
        </div>
        }
      </div>

      <!-- Declarations Section - Show with form fields -->
      @if (licenseExists || frontImageExists || backImageExists || showFormManually) {
      <div class="license-section">
        <div class="section-header">
          <h3>Declarations</h3>
        </div>
        <div class="field-row">
          <div>
            <span class="field-header">Have you ever been denied a license, permit or privilege to operate a motor
              Vehicle?<span class="required-indicator">*</span></span>
          </div>
          <mat-radio-group formControlName="hasDeniedLicense" class="radio-group" color="primary"
            data-test="denied-license">
            <mat-radio-button [value]="true" class="radio-button" data-testid="denied-license">Yes</mat-radio-button>
            <mat-radio-button [value]="false" class="radio-button" data-testid="notDenied-license">No</mat-radio-button>
          </mat-radio-group>
          @if (licenseForm.get('hasDeniedLicense').touched && licenseForm.get('hasDeniedLicense').invalid) {
          <mat-error class="field-error" data-testid="hasDeniedLicense-warning">
            {{ REQUIRED_FIELD_MESSAGE }}
          </mat-error>
          }
          @if (licenseForm.get('hasDeniedLicense').value) {
          <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
            <mat-label>Explain</mat-label>
            <input matInput type="text" minlength="1" maxlength="100" formControlName="deniedLicenseExplanation"
              required />
            @if (
            licenseForm.get('deniedLicenseExplanation').touched &&
            licenseForm.get('deniedLicenseExplanation').invalid
            ) {
            <mat-error data-testid="deniedLicense-warning">
              {{ REQUIRED_FIELD_MESSAGE }}
            </mat-error>
            }
          </mat-form-field>
          }
        </div>
        <div class="field-row">
          <div>
            <span class="field-header">Has any License, Permit or privilege ever been suspended or Revoked?<span
                class="required-indicator">*</span></span>
          </div>
          <mat-radio-group formControlName="hasSuspendedLicense" class="radio-group" color="primary"
            data-test="suspended-permit">
            <mat-radio-button [value]="true" class="radio-button" data-testid="suspended-permit">Yes</mat-radio-button>
            <mat-radio-button [value]="false" class="radio-button"
              data-testid="notSuspended-permit">No</mat-radio-button>
          </mat-radio-group>
          @if (licenseForm.get('hasSuspendedLicense').touched && licenseForm.get('hasSuspendedLicense').invalid) {
          <mat-error class="field-error" data-testid="hasSuspendedLicense-warning">
            {{ REQUIRED_FIELD_MESSAGE }}
          </mat-error>
          }
          @if (licenseForm.get('hasSuspendedLicense').value) {
          <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
            <mat-label>Explain</mat-label>
            <input matInput type="text" minlength="1" maxlength="100" formControlName="suspendedLicenseExplanation"
              required />
            @if (
            licenseForm.get('suspendedLicenseExplanation').touched &&
            licenseForm.get('suspendedLicenseExplanation').invalid
            ) {
            <mat-error data-testid="revokedLicense-warning">
              {{ REQUIRED_FIELD_MESSAGE }}
            </mat-error>
            }
          </mat-form-field>
          }
        </div>
      </div>
      }
    </div>
    }
    @if (!licenseLoaded) {
    <app-loading-gif></app-loading-gif>
    }
  </form>

  <!-- Saving Progress Overlay -->
  @if (isSaving) {
  <div class="saving-overlay">
    <div class="saving-card">
      <mat-spinner diameter="60" class="large-spinner"></mat-spinner>
      <h2 class="saving-title">Saving your license...</h2>
      <p class="saving-subtitle">Please wait while we process your information.</p>
      <div class="saving-steps">
        @if (savingStep === 'creating') {
        <div class="step active">
          <mat-icon>check_circle</mat-icon>
          <span>Creating license record...</span>
        </div>
        }
        @if (savingStep === 'updating' || savingStep === 'uploading' || savingStep === 'refreshing') {
        <div class="step completed">
          <mat-icon>check_circle</mat-icon>
          <span>License record created</span>
        </div>
        }
        @if (savingStep === 'updating') {
        <div class="step active">
          <mat-icon>check_circle</mat-icon>
          <span>Saving license details...</span>
        </div>
        }
        @if (savingStep === 'uploading' || savingStep === 'refreshing') {
        <div class="step completed">
          <mat-icon>check_circle</mat-icon>
          <span>License details saved</span>
        </div>
        }
        @if (savingStep === 'uploading') {
        <div class="step active">
          <mat-icon>cloud_upload</mat-icon>
          <span>Uploading images...</span>
        </div>
        }
        @if (savingStep === 'refreshing') {
        <div class="step completed">
          <mat-icon>check_circle</mat-icon>
          <span>Images uploaded</span>
        </div>
        <div class="step active">
          <mat-icon>refresh</mat-icon>
          <span>Finalizing...</span>
        </div>
        }
      </div>
    </div>
  </div>
  }
</div>
}